import notificationService from './NotificationService';
export var NOTIFICATION_TYPES = notificationService.types;
/**
 * Setting default options for Notifications
 * @param {*} options
 */

export function configureNotifications(options) {
  notificationService.configureNotifications(options);
}
/**
 * Displays success notifications on UI
 * @param {*} options { message: 'notification message' }
 */

export function showSuccessNotification(options) {
  notificationService.success(options);
}
/**
 * Displays error notifications on UI
 * @param {*} options { message: 'notification message' }
 */

export function showErrorNotification(options) {
  notificationService.error(options);
}
/**
 * Displays info notifications on UI
 * @param {*} options { message: 'notification message' }
 */

export function showInfoNotification(options) {
  notificationService.info(options);
}
/**
 * Displays warning notifications on UI
 * @param {*} options { message: 'notification message' }
 */

export function showWarningNotification(options) {
  notificationService.warning(options);
}
/**
 * To clear all the toasts or given type(s)
 * @param {string | array | undefined} byType
 */

export function clearNotifications(byType) {
  var count = notificationService.count;

  if (count > 0) {
    notificationService.destroy(byType);
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@shazambanking/sdk/services/notifications/notifications.js
// module id = 551
// module chunks = 0